import React, { useEffect } from "react";
import { useSnackbar } from "notistack";
import { Backdrop, CircularProgress } from "@mui/material";
import { getFormInvalid } from "../helpers/getFormInvalid";
import { checkInvalidField } from "../helpers/checkInvalidField";
import EditDialog from "../Dialogs/EditDialog";
import setupEdit from "../helpers/setupEdit";
import { processFiles } from "../helpers/processFiles";
import { onEditSaveAll } from "../helpers/onEditSaveAll";
import { onEditDeleteAll } from "../helpers/onEditDeleteAll";
import { getUserAccess } from "../helpers/getUserAccess";

export default function IssuesEdit(props) {
  // console.log(location.state);
  const { enqueueSnackbar } = useSnackbar();
  const [editDialogOpen, setEditDialogOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isReady, setIsReady] = React.useState(false);
  const [importTitle, setImportTitle] = React.useState("New Issue");
  const [editFeature, setEditFeature] = React.useState(null);
  const [editFiles, setEditFiles] = React.useState([]);
  const [editSchema, setEditSchema] = React.useState([]);
  const [project, setProject] = React.useState({});
  const [formErrorMessage, setformErrorMessage] = React.useState("");

  useEffect(() => {
    const fetchData = () => {
      try {
        onEdit(props.issue, props.project);
        setProject(props.project);
      } catch (error) {
        console.error("Error getting document:", error);
        enqueueSnackbar(error.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };
    if (editSchema.length === 0 && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  });

  const getAcceptedFiles = async (files) => {
    try {
      const readyFiles = await processFiles(files, "issue_id", editFeature.id);
      const allFiles = editFiles.concat(readyFiles);
      setEditFiles([...allFiles]);
    } catch (error) {
      console.error("Error getting document:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: "error",
      });
    }
  };

  const onEditFileCommentChange = (e) => {
    var file = editFiles.find((f) => f.id === e.target.id);
    file.comment = e.target.value;
    setEditFiles([...editFiles]);
  };

  const onDrawComplete = (id, pic) => {
    var file = editFiles.find((f) => f.id === id);
    if (file) {
      file.file = pic;
      if (!file.id.startsWith("new_")) {
        file.isDrawn = true;
      }
      setEditFiles([...editFiles]);
    }
  };

  const onRemoveEditFile = async (id) => {
    const updatedFiles = editFiles.map((obj) => {
      if (obj.id === id) {
        obj.deleted = true;
        return obj; // Replace the object if its ID matches
      }
      return obj; // Keep other objects as they are
    });

    setEditFiles([...updatedFiles]);
  };

  // const onAddIssue = () => {
  //   var item = {};
  //   var schema = getSchema("issue");
  //   schema.forEach((fd) => {
  //     item[fd.name] = "";
  //   });

  //   item["id"] = "new";
  //   item["project_id"] = project["id"];
  //   if (props.observationId !== null) {
  //     item["observation_id"] = props.observationId;
  //   }
  //   item = applyEditTrackingFields(item, props.user);

  //   setEditSchema(schema);
  //   setEditFeature(item);
  //   setEditFiles([]);
  //   setImportTitle("New Issue");
  //   setEditDialogOpen(true);
  // };

  const onEdit = (item, proj) => {
    const results = setupEdit({ ...item }, "issue");
    const files = proj.Files.filter((p) => p.issue_id === item.id);
    setIsLoading(false);
    setEditSchema(results.schema);
    setEditFeature({ ...results.item });
    setEditFiles([...files]);
    setImportTitle(`Edit Issue (No:${item.No})`);
    setEditDialogOpen(true);
  };

  const onEditDelete = async () => {
    try {
      setIsLoading(true);
      const savedProj = await onEditDeleteAll(
        project,
        editFeature,
        editFiles,
        "Issues",
        "issues_id",
        props.user,
      );

      // props.saveCurrentProject({ ...savedProj });
      setProject({ ...savedProj });
      // setAllTheIssues(savedProj.Issues);
      enqueueSnackbar("Issue deleted successfully", {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "success",
      });
      setEditDialogOpen(false);
      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  const onEditSave = async () => {
    try {
      //check for invalid
      var feat = { ...editFeature };
      var invalidResults = getFormInvalid(feat, editSchema);
      if (invalidResults.isInvalid === true) {
        setEditFeature({ ...invalidResults.feature });
        setEditSchema([...invalidResults.schema]);
        setformErrorMessage(invalidResults.formErrorMessage);
        return;
      }

      setIsLoading(true);

      var proj = { ...project };

      const savedProj = await onEditSaveAll(
        proj,
        feat,
        editSchema,
        editFiles,
        "Issues",
        "issue_id",
        props.user,
      );

      props.passUpProject(savedProj);

      enqueueSnackbar("Issue saved successfully", {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "success",
      });
      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  const onEditChange = (e) => {
    try {
      // console.log(e);
      var att = editSchema.find((item) => item.name === e.target.name);
      const formErrorMessage = checkInvalidField(e.target.value, att);
      if (att.type === "date") {
        if (e.target.value.length > 0) {
          var date = new Date(e.target.value);
          // date.setDate(date.getDate() + 1);
          editFeature[e.target.name] = date.toISOString().split("T")[0];
          // editFeature[e.target.name] = date.getTime();
          setEditFeature({ ...editFeature });
          setformErrorMessage(formErrorMessage);
        }
      } else if (att.type === "bit") {
        editFeature[e.target.name] = e.target.checked;
        setEditFeature({ ...editFeature });
        setformErrorMessage(formErrorMessage);
      } else {
        editFeature[e.target.name] = e.target.value;
        setEditFeature({ ...editFeature });
        setformErrorMessage(formErrorMessage);
      }
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
    }
  };

  const onEditCancel = () => {
    setformErrorMessage("");
    setEditDialogOpen(false);
    props.onEditClick();
  };

  return isLoading ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <EditDialog
      allowDeleteAccess={
        getUserAccess(props.user, project.uid, project.Contacts).allowDelete
      }
      feature={editFeature}
      editFiles={editFiles}
      importTitle={importTitle}
      getAcceptedFiles={getAcceptedFiles}
      onEditFileCommentChange={onEditFileCommentChange}
      onRemoveEditFile={onRemoveEditFile}
      schema={editSchema}
      onChange={onEditChange}
      onEditSave={onEditSave}
      onEditDelete={onEditDelete}
      isOpen={editDialogOpen}
      onClose={onEditCancel}
      formErrorMessage={formErrorMessage}
      allowDelete={false}
      allowFiles={true}
      onDrawComplete={onDrawComplete}
    />
  );
}
